import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

import {
  Panel,
  Text,
  InputNumber,
  HelpIcon,
  TooltipUtils,
  Flex,
  FlexItem
} from 'mailup-web-components'

import { abTestState } from '../recoil/state/abTest'

const AbTestSchedulingAutomaticAfter = () => {
  const intl = useIntl()
  const { schedulingAutomatic } = useRecoilValue(abTestState)
  const setAbTestState = useSetRecoilState(abTestState)

  const handleChange = e => {
    setAbTestState(prev => ({
      ...prev,
      IsDirty: true,
      schedulingAutomatic: e,
      schedulingAutomaticIsDirty: true
    }))
  }

  useEffect(() => {
    setTimeout(() => {
      TooltipUtils.rebuild()
    })
  }, [])

  return (
    <Panel collapsible={false}>
      <Flex alignItems='center'>
        <Text>
          {intl.formatMessage({
            id: 'Load.ABTestWizard.SchedulingAutomaticAfter'
          })}
        </Text>

        <FlexItem width='80px' margin='0 16px'>
          <InputNumber
            min={1}
            value={schedulingAutomatic}
            onChange={handleChange}
            variant={!schedulingAutomatic ? 'danger' : ''}
          />
        </FlexItem>
        <Text>{intl.formatMessage({ id: 'Load.MailupCommon.Hours' })}</Text>
        <FlexItem margin='0 0 0 4px'>
          <HelpIcon
            text={intl.formatMessage({
              id: 'Load.ABTestWizard.SchedulingAutomaticTooltip'
            })}
          />
        </FlexItem>
      </Flex>
    </Panel>
  )
}
export default AbTestSchedulingAutomaticAfter
